import PulseArticle from './PulseArticle';

export default PulseArticle;
